import {
  DATA_COPY_SUBMIT_REQUEST,
  DATA_COPY_SUBMIT_SUCCESS,
  DATA_COPY_SUBMIT_FAILURE,
  DATA_COPY_SUBMIT_DUPLICATE,
  CLICK_EMAIL_US_REQUEST,
  CLICK_EMAIL_US_SUCCESS,
  CLICK_EMAIL_US_FAILURE,
  SET_INITIAL_DATA,
  SET_INITIAL_COUNTRY,
  CHECK_CHAT_AVAILABILITY_REQUEST,
  CHECK_CHAT_AVAILABILITY_SUCCESS,
  CHECK_CHAT_AVAILABILITY_FAILURE,
  UPDATE_ISSUE_SELECTION,
  SET_DEFAULT_CONTACT_NOTE,
  SET_UPLOADED_FILES,
  SET_ENERGY_SCHEDULING_TEAM,
  SUBMIT_REIMBURSEMENT_REQUEST,
  SUBMIT_REIMBURSEMENT_SUCCESS,
  SUBMIT_REIMBURSEMENT_FAILURE,
  RESET_REQUEST_STATUS,
  UPLOAD_FILE_STATUS,
  DEMOGRAPHIC_FORM_INPUT_CHANGE,
  PAYOR_FORM_INPUT_CHANGE,
  RESET_PAYOR_FORM,
  SHOW_GLOBAL_LOADER,
  HIDE_GLOBAL_LOADER,
  FETCH_TROUBLESHOOTING_CONFIG,
  SET_TROUBLESHOOTING_GUIDE,
  SET_COMPLETED_TROUBLESHOOTING_GUIDE,
  SET_TROUBLESHOOTING_SUPPORT_OVERRIDES,
  CHECK_ACCOUNT_REQUEST,
  CHECK_ACCOUNT_SUCCESS,
  CHECK_ACCOUNT_FAILURE,
  CHAT_START,
} from './types';

const action = type => payload => ({
  type,
  payload,
});

export const dataCopyRequest = action(DATA_COPY_SUBMIT_REQUEST);
export const dataCopySuccess = action(DATA_COPY_SUBMIT_SUCCESS);
export const dataCopyFailure = action(DATA_COPY_SUBMIT_FAILURE);
export const dataCopyDuplicate = action(DATA_COPY_SUBMIT_DUPLICATE);

export const clickEmailUsRequest = action(CLICK_EMAIL_US_REQUEST);
export const clickEmailUsSuccess = action(CLICK_EMAIL_US_SUCCESS);
export const clickEmailUsFailure = action(CLICK_EMAIL_US_FAILURE);

export const checkChatAvailabilityRequest = action(CHECK_CHAT_AVAILABILITY_REQUEST);
export const checkChatAvailabilitySuccess = action(CHECK_CHAT_AVAILABILITY_SUCCESS);
export const checkChatAvailabilityFailure = action(CHECK_CHAT_AVAILABILITY_FAILURE);

export const chatStart = action(CHAT_START);

export const setInitialData = action(SET_INITIAL_DATA);
export const setInitialCountry = action(SET_INITIAL_COUNTRY);

export const updateIssueSelection = action(UPDATE_ISSUE_SELECTION);
export const setDefaultContactNote = action(SET_DEFAULT_CONTACT_NOTE);
export const setUploadedFiles = action(SET_UPLOADED_FILES);
export const setEnergySchedulingTeam = action(SET_ENERGY_SCHEDULING_TEAM);

export const submitReimbursementRequest = action(SUBMIT_REIMBURSEMENT_REQUEST);
export const submitReimbursementSuccess = action(SUBMIT_REIMBURSEMENT_SUCCESS);
export const submitReimbursementFailure = action(SUBMIT_REIMBURSEMENT_FAILURE);
export const resetRequestStatus = action(RESET_REQUEST_STATUS);

export const uploadFileStatus = action(UPLOAD_FILE_STATUS);

export const demographicFormInputChange = action(DEMOGRAPHIC_FORM_INPUT_CHANGE);
export const payorFormInputChange = action(PAYOR_FORM_INPUT_CHANGE);
export const resetPayorForm = action(RESET_PAYOR_FORM);

export const showGlobalLoader = action(SHOW_GLOBAL_LOADER);
export const hideGlobalLoader = action(HIDE_GLOBAL_LOADER);

export const fetchTroubleshootingGuideConfig = action(FETCH_TROUBLESHOOTING_CONFIG);
export const setTroubleshootingGuide = action(SET_TROUBLESHOOTING_GUIDE);
export const setCompletedTroubleshootingGuide = action(SET_COMPLETED_TROUBLESHOOTING_GUIDE);
export const setTroubleshootingSupportOverrides = action(SET_TROUBLESHOOTING_SUPPORT_OVERRIDES);

export const checkAccountRequest = action(CHECK_ACCOUNT_REQUEST);
export const checkAccountSuccess = action(CHECK_ACCOUNT_SUCCESS);
export const checkAccountFailure = action(CHECK_ACCOUNT_FAILURE);
